"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const MyStructureSingleBranch_1 = tslib_1.__importDefault(require("./MyStructureSingleBranch"));
const MyStructureBranches = (props) => {
    const { structuralUnits, hook, openParent, closeParent, handleOpenHierarchy, fetchingHierarchy } = props;
    const getClassNamesForTree = (unit) => {
        return [
            'jstree-node btn-hover-primary',
            !unit.hasChildren && 'jstree-leaf',
            unit.isOpen && unit.children?.length > 0 ? 'jstree-open' : 'jstree-closed',
            unit.isLastNode && 'jstree-last',
            hook.state.loadingItems.includes(unit.identifier) && 'jstree-loading'
        ].filter(Boolean).join(' ');
    };
    return ((0, jsx_runtime_1.jsx)("ul", { className: 'jstree-children', children: structuralUnits.map((unit) => ((0, jsx_runtime_1.jsxs)("li", { className: getClassNamesForTree(unit), children: [(0, jsx_runtime_1.jsx)(MyStructureSingleBranch_1.default, { structuralUnit: unit, openParent: openParent, closeParent: closeParent, isLoading: hook.state.loadingItems.includes(unit.identifier), handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy }), unit.children.length > 0 && ((0, jsx_runtime_1.jsx)("ul", { children: unit.children && unit.isOpen
                        ? (0, jsx_runtime_1.jsx)(MyStructureBranches, { structuralUnits: unit.children, hook: hook, openParent: openParent, closeParent: closeParent, handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy }, unit.id)
                        : null }))] }, unit.id))) }));
};
exports.default = MyStructureBranches;
